/** Base para leer los parámetros de una `redirect_url` relativa o cortada (p. ej. `?centroid_lat=...` sin dominio). */
const RELATIVE_URL_BASE = 'http://localhost';

/**
 * `centroid_lat` / `centroid_long` de la `redirect_url` → `{ lat, lng }`, o `null` si faltan o no son números.
 * Es el **respaldo** del centroide: la fuente principal es la key `centroid` de `GET /ranch/`. Acepta la URL cortada
 * (solo la query) porque el backend la ha mandado así, y con `new URL(url)` eso escondía todo el indicador.
 */
export function getPolygonCentroidFromUrl(
    url: string
): { lat: number, lng: number } | null {
  try {
    const u = new URL(url, RELATIVE_URL_BASE);

    const latRaw = u.searchParams.get("centroid_lat");
    const lngRaw = u.searchParams.get("centroid_long");

    if (!latRaw || !lngRaw) {
      return null;
    }

    const lat = parseFloat(latRaw);
    const lng = parseFloat(lngRaw);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    return { lat, lng };
  } catch (e) {
    return null;
  }
}
